const ICONS = {
    PYTHON: '',
    DJANGO: '',
    JAVASCRIPT: '',
    RUBY: '',
    PHP: '',
};

export const projects = [
    {
        id: 'britecharts',
        name: 'Britecharts',
        description:
            'Britecharts is a client-side reusable Charting Library based on D3.js v5 that offers easy and intuitive use of charts and components that can be composed together to create amazing visualizations.',
        url: 'https://github.com/eventbrite/britecharts',
        thumbnail:
            'https://cdn.evbuc.com/images/63128017/270213568554/1/original.20200114-185357',
        technology: 'd3',
    },
    {
        id: 'britecharts-react',
        name: 'Britecharts-React',
        description:
            'Britecharts-react is a React wrapper for the Britecharts charting library. It allows the use of Britecharts charts within a React application.',
        url: 'https://github.com/eventbrite/britecharts-react',
        thumbnail:
            'https://cdn.evbuc.com/images/63128021/270213568554/1/original.20200114-192937',
        technology: 'd3',
    },
    {
        id: 'pysoa',
        name: 'PySOA',
        description:
            'PySOA is a general-purpose library for writing Python microservices based on an RPC (remote procedure call) calling style. PySOA provides both a client and a server, which can be used directly by themselves or extended with extra functionality.',
        url: 'https://github.com/eventbrite/pysoa',
        thumbnail: '',
        technology: 'python',
    },
    {
        id: 'conformity',
        name: 'Conformity',
        description:
            'Conformity is a low-level, declarative schema validation library for Python that is extremely lightweight and sustains a very high throughput with latency measured in a handful of microseconds.',
        url: 'https://github.com/eventbrite/conformity',
        thumbnail: '',
        technology: 'python',
    },
    {
        id: 'tikibar',
        name: 'Tikibar',
        description:
            'Tikibar is a debugging and information toolbar for Django, designed for lightweight impact so it can be enabled selectively and run in production.',
        url: 'https://github.com/eventbrite/tikibar',
        thumbnail: '',
        technology: 'django',
    },
    {
        id: 'invoke-release',
        name: 'Invoke Release',
        description:
            'Invoke Release is a set of command-line tools that help software engineers release Python projects quickly, easily, and in a consistent manner. Invoke Release helps ensure version standards for your projects and minimizes the possible errors that can occur during a release.',
        url: 'https://github.com/eventbrite/invoke-release',
        thumbnail: '',
        technology: 'python',
    },
    {
        id: 'pymetrics',
        name: 'PyMetrics',
        description:
            'PyMetrics is a versatile metrics collection library for Python that encapsulates the collection of counters, gauges, histograms, and timers into a generic interface with pluggable publishers so that you can helpfully instrument your applications without suffering vendor lock.',
        url: 'https://github.com/eventbrite/pymetrics',
        thumbnail: '',
        technology: 'python',
    },
    {
        id: 'fbpysdk',
        name: 'Facebook Py SDK',
        description:
            'facebook-py-sdk is a Python library that helps developers to connect and make requests to the Facebook Graph API easily. It also simplifies the way of sending requests and uploading photos in batches.',
        url: 'https://github.com/eventbrite/facebook-py-sdk',
        thumbnail: '',
        technology: 'python',
    },
];

export const sdks = [
    {
        id: 'js-sdk',
        name: 'JavaScript SDK',
        description:
            'Eventbrite’s official JavaScript SDK is a collection of helpers and wrappers that simplify using the Eventbrite v3 API on web and node clients.',
        url: 'https://github.com/eventbrite/eventbrite-sdk-javascript',
        logo: '',
        thumbnail: '',
        technology: 'js',
    },
    {
        id: 'ruby-sdk',
        name: 'Ruby SDK',
        description:
            "Eventbrite's official Ruby SDK library provides convenient access to the v3 API for the Ruby language. It includes a pre-defined set of classes for API resources that initialize themselves dynamically from API responses for ease of use in your application.",
        url: 'https://github.com/eventbrite/eventbrite-sdk-ruby',
        logo: '',
        thumbnail: '',
        technology: 'ruby',
    },
    {
        id: 'php-sdk',
        name: 'PHP SDK',
        description:
            "Eventbrite's official PHP SDK is a collection of helpers and wrappers that simplifies using the Eventbrite V3 API on your PHP projects.",
        url: 'https://github.com/eventbrite/eventbrite-sdk-php',
        logo: '',
        thumbnail: '',
        technology: 'php',
    },
    {
        id: 'python-sdk',
        name: 'Python SDK',
        description:
            "Eventbrite's official Python SDK is a collection of helpers and wrappers that simplifies using the Eventbrite V3 API on your Python projects.",
        url: 'https://github.com/eventbrite/eventbrite-sdk-python',
        logo: '',
        thumbnail: '',
        technology: 'python',
    },
];

export const books = [
    {
        id: 'jquery-mobile-web-development-essentials-III',
        name: 'jQuery Mobile Web Development Essentials - Third Edition',
        author: 'Andy Matthews',
        description:
            "This book explains how to add the framework to your HTML pages to create rich, mobile-optimized web pages with minimal effort. You'll learn how to use jQuery Mobile's automatic enhancements and configure the framework for customized, powerful mobile-friendly websites.",
        url: 'https://amzn.to/2tiJGTz',
        thumbnail:
            'https://cdn.evbuc.com/images/63128015/270213568554/1/original.20200114-184643',
        website: 'https://www.commadelimited.com/',
    },
    {
        id: 'jquery-mobile-web-development-essentials-II',
        name: 'Creating Mobile Apps with jQuery Mobile - Second Edition',
        author: 'Andy Matthews',
        description:
            'Learn how to automate repetitive tasks easily and painlessly with the Grunt task runner, build a fully responsive, gorgeous photography website, and learn how to mix and match jQuery Mobile 1.4.5 into existing websites and how to deploy those changes to content management systems such as WordPress, Drupal, and HarpJS.',
        url: 'https://amzn.to/36Iui1d',
        thumbnail:
            'https://cdn.evbuc.com/images/63128011/270213568554/1/original.20200114-184220',
        website: 'https://www.commadelimited.com/',
    },
    {
        id: 'professional-java-for-web-apps',
        name: 'Professional Java for Web Applications',
        author: 'Nicholas S. Williams',
        description:
            'This guide shows Java software engineers how to build complex web applications in an enterprise environment. It covers industry-standard tools and technologies and underlying programming concepts, including Java EE, JPA, Hibernate, and Spring Framework.',
        url: 'https://amzn.to/35qij8g ',
        thumbnail:
            'https://cdn.evbuc.com/images/63128013/270213568554/1/original.20200114-184550',
    },
    {
        id: 'pro-d3-js',
        name: 'Pro D3.js',
        author: 'Marcos Iglesias',
        description:
            'Go beyond the basics of D3.js to create maintainable, modular, and testable charts and to package them into a library that can be distributed as open source software or kept for private use.',
        url: 'http://bit.ly/pro-d3js',
        thumbnail:
            'https://cdn.evbuc.com/images/63128009/270213568554/1/original.20200114-184145',
        website: 'https://www.marcosiglesias.com',
    },
];
